import { createSelector } from '@reduxjs/toolkit'
import { IStore } from 'redux/types'

export const selectAuthForm = createSelector(
	(state: IStore) => state.authForm,
	(authFormState) => authFormState
)
